import { CSSProperties } from "react";

export const buttonWithPanelStyles = {
  button: {
    marginRight: 4,
    padding: "var(--spacingHorizontalXS) 5px"
  } as CSSProperties,

  defaultHeaderStyle: {
    color: "var(--colorBrandBackground)",
    fontSize: "larger"
  } as CSSProperties
};
